import http from '../http-common'

class EditorTemplatesService {
  getTemplates(tenant_id) {
    return http.get(`/api/templates?tenant_id=${tenant_id}`).catch(e => e.response)
  }

  createTemplate(tenant_id, data) {
    return http.post(`/api/templates?tenant_id=${tenant_id}`, data).catch(e => e.response)
  }

  updateTemplate(tenant_id, data) {
    return http.put(`/api/templates/${data.id}?tenant_id=${tenant_id}`, data).catch(e => e.response)
  }

  deleteTemplate(id, tenant_id) {
    return http.delete(`/api/templates/${id}?tenant_id=${tenant_id}`).catch(e => e.response)
  }
}

export default new EditorTemplatesService()
